function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 17 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.302,1.379C12.556,1.125 12.683,0.998 12.81,0.913C13.329,0.566 14.007,0.566 14.526,0.913C14.653,0.998 14.78,1.125 15.033,1.379C15.287,1.632 15.414,1.759 15.499,1.886C15.846,2.405 15.846,3.083 15.499,3.602C15.414,3.729 15.287,3.856 15.033,4.11L6.665,12.478C6.461,12.682 6.359,12.785 6.24,12.866C6.121,12.947 5.989,13.005 5.725,13.121L5.015,13.434C3.48,14.109 2.713,14.447 2.339,14.073C1.966,13.699 2.303,12.932 2.978,11.398L3.291,10.688C3.407,10.423 3.465,10.291 3.546,10.172C3.628,10.054 3.73,9.951 3.934,9.747L12.302,1.379Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(140,140,140)",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.184,3.471L12.915,6.202",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(140,140,140)",
      strokeWidth: "1.3px",
      strokeLinecap: "butt"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNormal);
export default __webpack_public_path__ + "static/media/edit_normal.996d7042164c99e63e74f67a4119785e.svg";
export { ForwardRef as ReactComponent };